/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UserGrantDto {
  email?: string;
  fineGrainedGrants?: Array<string>;
  firstName?: string;
  grants?: Array<string>;
  id?: number;
  lastLogin?: string;
  lastName?: string;
  password?: string;
  token?: string;
  tokenId?: string;
  userRole?: string;
  userState?: string;
  username?: string;
}
